import { render } from "./ChatMessageCard.vue?vue&type=template&id=4c3017a2"
import script from "./ChatMessageCard.vue?vue&type=script&lang=js"
export * from "./ChatMessageCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__